import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import SceneProperties from '../../data/SceneProperties';
import useEvent from '../../hooks/useEvent';

function Settings() {
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isMute, setIsMute] = useState(SceneProperties.isMute);
    const [speed, setSpeed] = useState(SceneProperties.speed);

    const toggleSettingsMenu = () => {
        setIsSettingsOpen(!isSettingsOpen);

        let btn = document.querySelector(".sidebar__hamburger") as HTMLElement;
        if (btn !== null) {
            if (!isSettingsOpen) {
                //open!
                btn.style.zIndex = "2";
            } else {
                btn.style.zIndex = "1000";
            }
        }
    }

    const getSettingsToggleClass = () => {
        return isSettingsOpen ? "open" : "";
    }

    const toggleSound = () => {
        setIsMute(!isMute);
    }

    const increment = (val: number) => {
        if (!isSettingsOpen) return;

        var trial: number = speed + val;

        if (trial > 5) trial = 5;
        if (trial < 1) trial = 1;

        setSpeed(trial);
    }

    const handleKeyPress = (e: KeyboardEvent) => {
        let key = e.key;

        switch (key) {
            case 'm':
                toggleSound();
                break;
            case 's':
                let btn = document.querySelector(".settingsBtn") as HTMLElement;
                if (btn !== null) {
                    if (btn.style.zIndex !== "2") {                        
                        toggleSettingsMenu();
                    }
                }
                break;
            case 'a':
                increment(-1);
                break;
            case 'd':
                increment(1);
                break;
            default:
                break;
        }
    }

    useEvent('keydown', handleKeyPress);

    const getLabel = () => {
        var str = speed + ". ";

        if (speed === 1 || speed === 5) {
            str += "Xtra ";
        }

        if (speed < 3) {
            str += "Easy"
        } else if (speed === 3) {
            str += "Medium"
        } else {
            str += "Hard"
        }

        return str;
    }

    const handleSpeed = (event: any) => {
        setSpeed(event.target.value);
    }

    SceneProperties.speed = speed;
    SceneProperties.isMute = isMute;

    return <>
        <div className='settingsBtn' onClick={toggleSettingsMenu}>
            <FontAwesomeIcon icon={faCog} color={'white'} className={getSettingsToggleClass()} />
        </div>
        <div className={`sidebar__overlay ${getSettingsToggleClass() === "open" ? "open fade-in" : "fade-out"}`} onClick={toggleSettingsMenu}></div>
        <div className={`settingsModal ${getSettingsToggleClass() === "open" ? "open fade-in" : "fade-out"}`}>
            <div className='col'>
                <div className='text'>
                    Sound
                </div>
                <div className='text'>
                    Speed
                </div>
            </div>
            <div className='col'>
                <div onClick={toggleSound}>
                    <FontAwesomeIcon icon={isMute ? faVolumeMute : faVolumeUp} color={'white'} className="sound" />
                    <span>{`${isMute ? "Muted" : "Sound On"}`}</span>
                </div>
                <div>
                    <input type="range" id="points" name="points" step={1} min="1" max="5" value={speed} onChange={handleSpeed}></input>
                    <span>{getLabel()}</span>
                </div>
            </div>
        </div>
    </>;
}

export default Settings;
